import React from 'react';
import EyebrowPill from './EyebrowPill';

export default function SectionHeader({ 
  eyebrow, 
  title,
  titleEm,
  subtitle, 
  center = false,
  variant = 'dark',
  className = '',
}) {
  const titleColor = variant === 'light' ? 'text-cream' : 'text-warm-black';
  const subColor = variant === 'light' ? 'text-cream/70' : 'text-muted';
  const eyebrowVariant = variant === 'light' ? 'cream-on-dark' : 'dark';
  
  return (
    <div className={`${center ? 'text-center max-w-[780px] mx-auto' : 'max-w-container-narrow mx-auto'} mb-[70px] ${className}`}>
      {eyebrow && (
        <EyebrowPill variant={eyebrowVariant} className="mb-[22px]">
          {eyebrow}
        </EyebrowPill>
      )}
      {title && (
        <h2 className={`font-serif font-medium text-display-m ${titleColor} mb-5`}>
          {title}
          {titleEm && (
            <> <em className="italic text-gold">{titleEm}</em></>
          )}
        </h2>
      )}
      {subtitle && (
        <p className={`text-[17px] leading-[1.6] max-w-[580px] ${center ? 'mt-[18px] mx-auto' : ''} ${subColor}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}